import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const CheckCircleSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<path
				d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
				fill="#4A4A4A"
			/>
			<g clipPath="url(#clip0_15447_64245)">
				<path
					d="M17 9L10.3658 16L7 12.6339"
					stroke="white"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_15447_64245">
					<rect width="12" height="9" fill="white" transform="translate(6 8)" />
				</clipPath>
			</defs>
		</IPortIconTemplate>
	)
})
